import { ReservationApi } from 'Src/types/api.types'

export function sanitizeCheckinData(data: unknown): ReservationApi {
	// @ts-expect-error Removing potentially problematic properties that may not exist on ReservationApi
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { query, id, ...sanitizedData } = data

	return sanitizedData
}
